import {ActionTypes} from './types';

export function ALTER_MODE_OPERATION(isControlID: boolean) {
  return {
    type: ActionTypes.SET_MODE_OPERATION,
    payload: isControlID
  };
}
